import { Flex } from "@chakra-ui/react";
import { StatusManutencaoEnum } from "features/manutencao/typings";
import ConteudoButtonManutencao from "./../ConteudoButtonManutencao";
import {
  getColorStatus,
  getBackgroundColorStatus,
  getIconStatus,
  getColorBorderIconStatus,
} from "./util";

interface CardEquipamentoProp {
  label: string;
  onClick: any;
  equipamentoStatus: string | undefined;
  dataManutencao: string | undefined;
}

export default function CardEquipamento({
  label,
  onClick,
  equipamentoStatus,
  dataManutencao,
}: CardEquipamentoProp) {
  return (
    <Flex
      cursor="pointer"
      onClick={onClick}
      height="60px"
      rounded={14}
      border={`solid 1px ${getBackgroundColorStatus(
        equipamentoStatus as StatusManutencaoEnum
      )}`}
      align="center"
      px={4}
      fontSize="16px"
      fontWeight="bold"
      justifyContent="space-between"
      boxShadow="0 2px 10px 2px rgba(0,0,0,.15)"
    >
      {label}
      <ConteudoButtonManutencao
        bgColor={getColorStatus(equipamentoStatus as StatusManutencaoEnum)}
        color={getColorBorderIconStatus(
          equipamentoStatus as StatusManutencaoEnum
        )}
        icon={getIconStatus(equipamentoStatus as StatusManutencaoEnum)}
      />
    </Flex>
  );
}
